module.exports = __webpack_public_path__ + "static/assets/38b73e5ade34f2dfc6bbcd185de64952.png";